import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/F1_Photovoltaic.svg"

const F1Photovoltaic: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 20 13'} component={Icon} {...props} fill="currentColor" />
export default F1Photovoltaic
